<template>
	<div class="llogin">
		<div class="login" @click.stop="">
			<div class="from padding">
				<img class="block-119" src="../../../assets/img/success.png" >
				<p class="margin-top">您的发票申请已提交</p>
				<p class="margin-top-sm">{{type | fitytype}}</p>
			</div>
			<div class="padding-top-sm ">
				<div class="flex align-center padding-lr-lg justify-between height60 solid-bottom">
					<p class="text-999 text-df">开票金额</p>
					<p class="text-theme text-bold">{{price}}元</p>
				</div>
				<div class="flex align-center padding-lr-lg justify-between height60">
					<p class="text-999 text-df">开票内容</p>
					<p class="text-333 text-df">{{content}}</p>
				</div>
			</div>
			<div class="btn text-white">我的开票记录</div>
			<p class="text-999 text-sm">发布成功后，平台会在1个工作日内审核完成给与反馈</p>
			<i class="el-icon-close close text-999 pointer" @click="closesub"></i>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		},
		created() {
			Bus.$on('showsub',data=>{
				
			})
		},
		destroyed() {
			Bus.$off()
		},
		methods: {
			//关闭添加章节弹窗
			closesub(){
				this.$emit('closesub')
			},
		},
		filters:{
			fitytype(val){
				switch (val) {
					case "2":
						return '企业'
						break;
					case "1":
						return '个人'
						break;
					default:
						break;
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.llogin {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		background: rgba(4, 4, 4, 0.6600);
		z-index: 999999;
	}

	.login {
		width: 480px;
		height: 630px;
		background: #fff;
		position: relative;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		// box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 20px;
		&::before{
			position: absolute;
			content: '';
			width: 50px;
		    height: 50px;
		    border-radius: 50%;
		    left: -30px;
		    top:45%;
		    background: #575757;
		}
		&::after{
			position: absolute;
			content: '';
			width: 50px;
		    height: 50px;
		    border-radius: 50%;
		    right: -30px;
		    top: 45%;
		    background: #575757;
		}
		.close{
			position: absolute;
			top: 15px;
			right: 15px;
			font-size: 35px;
		}
		.block-119{
			width: 119px;
			height: 118px;
		}
		.from{
			padding-top: 55px;
			padding-bottom: 40px;
			border-bottom: 1px dashed #CCCCCC;
			// padding: 0 40px;
		}
		.padding-lr-lg{
			padding-left: 50px;
			padding-right: 50px;
		}
		.height60{
			height: 60px;
		}
		.solid-bottom{
			border-bottom: 2px solid #DEDEDE;
		}
	}
	.btn{
		width: 289px;
		height: 44px;
		line-height: 44px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2);
		border-radius: 22px;
		margin: 40px auto 25px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/invoice/submit.vue